import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SyncType } from '@era/locations-sdk';
import { NgClass } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'era-device-sync-status-retry-ui',
  templateUrl: './device-sync-status-retry.component.html',
  styleUrls: ['./device-sync-status-retry.component.scss'],
  imports: [NgClass, FaIconComponent],
})
export class DeviceSyncStatusRetryComponent {
  @Input() syncType: SyncType;
  @Input() allowRetry = false;

  @Output() public readonly scheduleTaskEvent: EventEmitter<SyncType> = new EventEmitter<SyncType>();

  public retrySync() {
    this.scheduleTaskEvent.emit(this.syncType);
  }
}
